var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    attrs: { id: "help-modal", "modal-header": false, "loaders-disabled": "" },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c("div", { staticClass: "row px-3 mb-4" }, [
              _c("h5", { staticClass: "bold" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("templates.beePlugin.emailEditorHelp")) +
                    "\n      "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "justified progress-text" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("templates.beePlugin.allowedSubstitutions")) +
                  "\n      "
              ),
              _c(
                "code",
                { staticClass: "text-center d-block text-primary mt-3" },
                [_vm._v("\n        " + _vm._s(_vm.namesTag) + "\n      ")]
              ),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "justified progress-text" }, [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t("templates.beePlugin.additionalAllowedSubstitutions")
                  ) +
                  "\n      "
              ),
              _c(
                "code",
                { staticClass: "text-center d-block text-primary mt-3" },
                [_vm._v("\n        " + _vm._s(_vm.addressTag) + "\n      ")]
              ),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "justified progress-text" }, [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t("templates.beePlugin.substitutePhysicalAddress")
                  ) +
                  "\n    "
              ),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "justified progress-text" }, [
              _c(
                "code",
                { staticClass: "text-center d-block text-primary mt-3" },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.emailSignatureTag) + "\n      "
                  ),
                ]
              ),
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t("templates.beePlugin.substituteEmailSignature")
                  ) +
                  "\n    "
              ),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }